export var BOARD_ICON_COLOR = '#55C3C1';
// Prefer the property's mapped board label; generated PMS service codes are not useful display labels.
export var getBoardLabel = function (stay) {
    var _a, _b;
    var mealCode = (_a = stay.mealCode) === null || _a === void 0 ? void 0 : _a.trim();
    if (mealCode)
        return mealCode;
    var rateCode = (_b = stay.rateCode) === null || _b === void 0 ? void 0 : _b.trim();
    return rateCode && !/^PMS_/i.test(rateCode) ? rateCode : undefined;
};
